<template>
    <v-expansion-panels 
        v-model="panel"
    >
        <v-expansion-panel
            v-for="(section,i) in prospectus_sections"
            :key="i">
            <v-expansion-panel-header class="primary title panel_title">
                <v-row no-gutters v-if="editListing.id && section.id == 'basic_info'">
                    {{ section.title }}:
                    <div class="ml-9">{{ editListing.listing_id }}</div>
                    <v-divider vertical class="mx-6" color="#ECEFF1"></v-divider>
                    <div><span class="font-weight-thin">Buyers:</span>
                        <span span v-if="parseInt(editListing.touch_buyers)" class="ml-2 mr-1">
                            <v-badge color="error" :content="editListing.touch_buyers">{{ editListing.buyer_ratio }}</v-badge>
                        </span>
                        <span span v-else class="ml-2">
                            {{ editListing.buyer_ratio }}
                        </span>
                    </div>
                    <v-divider vertical class="mx-6" color="#ECEFF1"></v-divider>
                    <div><span class="font-weight-thin">Status:</span><span class="ml-2" v-html="editListing.status_name"></span></div>
                    <v-divider vertical class="mx-6" color="#ECEFF1"></v-divider>
                    <div><span class="font-weight-thin">Stage:</span><span class="ml-2" v-html="editListing.stage_name"></span></div>
                    <v-divider vertical class="mx-6" color="#ECEFF1"></v-divider>
                    <div><span class="font-weight-thin">Active:</span> {{ editListing.is_active ? 'Yes' : 'No' }}</div>
                    <!-- <div><span class="font-weight-thin">Post Date:</span> {{ listing_postdate }}</div> -->
                    <!-- <div><span class="font-weight-thin">Anticipated Close Date:</span> {{ listing_closedate }}</div> -->
                </v-row>
                <v-row v-else no-gutters>
                    {{ section.title }}
                </v-row>
                <template v-slot:actions>
                    <v-icon color="pewter">
                        mdi-chevron-down
                    </v-icon>
                </template>
            </v-expansion-panel-header>
            
            <v-expansion-panel-content class="">
                <div v-if="section.id == 'basic_info'">
                    <BasicInfo 
                        :editData="editListing"
                        :states="lists.states"
                        :listing_statuses="lists.listing_statuses"
                        :listing_stages="lists.listing_stages"
                        :listing_types="lists.listing_types" />
                </div>
                
                <div v-else-if="section.id == 'owner_info'">
                    <OwnerInfo 
                        :editData="editListing" />
                </div>

                <div v-else-if="section.id == 'team_info'">
                    <TeamInfo 
                        :editData="editListing" />
                </div>

                <div v-else-if="section.id == 'company_info'">
                    <CompanyInfo 
                        :editData="editListing"
                        :insuranceBasedListings="insuranceBasedListings" />
                </div>

                <div v-else-if="section.id == 'hisctorical_revenue'">
                    <HistoricalRevenue 
                        :editData="editListing" />
                </div>

                <div v-else-if="section.id == 'revenue_breakdown'">
                    <RevenueBreakdown 
                        :editData="editListing"
                        @calcExpensesPercentageRevenue="calcExpensesPercentageRevenue" />
                </div>

                <div v-else-if="section.id == 'other_revenue'">
                    <OtherRevenueDetails 
                        :editData="editListing"
                        :insuranceBasedListings="insuranceBasedListings" />
                </div>               

                <div v-else-if="section.id == 'expense_breakdown'">
                    <ExpenseBreakdown 
                        :editData="editListing"
                        @calcExpensesPercentageRevenue="calcExpensesPercentageRevenue" />
                </div>

                <div v-else-if="section.id == 'client_demo'">
                    <ClientDemographic 
                        :editData="editListing"
                        :insuranceBasedListings="insuranceBasedListings" />
                </div>

                <div v-else-if="section.id == 'tech_use'">
                    <TechnologyUse 
                        :editData="editListing" />
                </div>

                <div v-else-if="section.id == 'comm_methods'">
                    <CommunicationMethods 
                        :editData="editListing"
                        :methodsList="lists.communication_methods" />
                </div>

                <div v-else-if="section.id == 'buyer_requirements'">
                    <BuyerRequirements 
                        :editData="editListing"
                        :insuranceBasedListings="insuranceBasedListings" />
                </div>

                <div v-else-if="section.id == 'retained_expenses'">
                    <AnnualRetainedExpenses 
                        :editData="editListing" />
                </div>

                <div v-else-if="section.id == 'price_terms'">
                    <PriceAndTerms 
                        :editData="editListing" />
                </div>


                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="primary darken-1" 
                        class="ml-5" 
                        :loading="saving_listing_data"
                        @click="updateData">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import BasicInfo from './BasicInfo'
    import PriceAndTerms from './PriceAndTerms'
    import BuyerRequirements from './BuyerRequirements'
    import OtherRevenueDetails from './OtherRevenueDetails'
    import AnnualRetainedExpenses from './AnnualRetainedExpenses'
    import OwnerInfo from './OwnerInfo'
    import TeamInfo from './TeamInfo'
    import CompanyInfo from './CompanyInfo'
    import HistoricalRevenue from './HistoricalRevenue'
    import RevenueBreakdown from './RevenueBreakdown'
    import ExpenseBreakdown from './ExpenseBreakdown'
    import ClientDemographic from './ClientDemographic'
    import TechnologyUse from './TechnologyUse'
    import CommunicationMethods from './CommunicationMethods'

    export default {
        name: 'EditProspectus',
        
        components: {
            BasicInfo,
            PriceAndTerms,
            BuyerRequirements,
            OtherRevenueDetails,
            AnnualRetainedExpenses,
            OwnerInfo,
            TeamInfo,
            CompanyInfo,
            HistoricalRevenue,
            RevenueBreakdown,
            ExpenseBreakdown,
            ClientDemographic,
            TechnologyUse,
            CommunicationMethods,
        },
        
        props: {
            editListing: Object,
            lists: Object,
            savingListingData: Boolean,
            updateListing: Function
        },

        data: () => ({
            name: 'EditProspectus',
            prospectus_sections: [
                { title: 'Basic Info',                  id:'basic_info'         },
                { title: 'Owner Info',                  id:'owner_info'         },
                { title: 'Team Info',                   id:'team_info'          },
                { title: 'Company Info',                id:'company_info'       },
                { title: 'Historical Revenue',          id:'hisctorical_revenue'},
                { title: 'Revenue Breakdown',           id:'revenue_breakdown'  },
                { title: 'Other Revenue Details',       id:'other_revenue'      },
                { title: 'Expense Breakdown',           id:'expense_breakdown'  },
                { title: 'Client Demographic',          id:'client_demo'        },
                { title: 'Technology Use',              id:'tech_use'           },
                { title: 'Communication Methods',       id:'comm_methods'       },
                { title: 'Buyer Requirements',          id:'buyer_requirements' },
                { title: 'Annual Retained Expenses',    id:'retained_expenses'  },
                { title: 'Price & Terms',               id:'price_terms'        },
            ],
            panel: 0,
            listing_postdate: '',
            listing_closedate: '',
            saving_listing_data: false,
            insuranceBasedListings: [8], // 3,7
            taxBasedListings: [10]
        }),

        watch: {
            savingListingData () {
                this.saving_listing_data = false
            }
        },
        
        methods: {
            setDisplayDates: function () {
                const anticipated_close_date = new Date(this.editListing.anticipated_close_date);
                const options = { year: 'numeric', month: 'long', day: 'numeric' };

                this.listing_closedate = anticipated_close_date.toLocaleDateString('en-US', options);
                // this.listing_postdate = dateFormat(this.editListing.post_date, "mmmm dS, yyyy")
                // this.listing_closedate = this.editListing.anticipated_close_date ? dateFormat(this.editListing.anticipated_close_date, "mmmm dS, yyyy") : 'undefined'
            },

            calcExpensesPercentageRevenue: function (data) {
                if ( data.expenses_total_overhead != undefined && data.revenue_t12_months != undefined ) {
                    this.editListing.expenses_percent_of_revenue = ((data.expenses_total_overhead / data.revenue_t12_months) * 100).toFixed(2);
                    //console.log(this.editListing.expenses_percent_of_revenue) 
                } else {
                    this.editListing.expenses_percent_of_revenue = 0
                }
            },
            
            updateData: function () {
                this.saving_listing_data = true
                this.$emit('updateListing', this.editListing );
            }
        }
    }
</script>

<style scoped>
    .panel_title {
        color: #ECEFF1;
    }
</style>


// WEBPACK FOOTER //
// src/components/prospectus-sections/index.vue